var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pcindexc-content"},_vm._l((_vm.content),function(item,index){return _c('div',{staticClass:"img-item",on:{"click":function($event){return _vm.todetails(item.id)}}},[_c('img',{attrs:{"src":item.image}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }